import { SegmentsTypeByUsage } from "app/pages/segments/analysis/constants/common";

export const segmentsAvailableMap = {
    [SegmentsTypeByUsage.singleSegment]: "availableForSegment",
    [SegmentsTypeByUsage.groupSegment]: "availableForSegmentsGroup",
    [SegmentsTypeByUsage.industrySegments]: "availableForCustomIndustry",
};
